<template>
  <a-modal
    width="1000px"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="保存"
  >
    <a-row :gutter="24">
      <a-col :span="8">
        <from-render
          ref="render"
          :form="modifyModal.form"
          :model="modifyModal.form.model"
          :options="modifyModal.options"
          :validateInfos="modifyModal.validateInfos"
        />
      </a-col>
      <a-col :span="16">
        <label title="卡详情">卡详情</label>
        <a-button type="primary" size="small" @click="() => handleAddCardRow()">新增</a-button>
        <a-table
          :scroll="{ y: 400 }"
          :columns="state.card.columns"
          row-key="id"
          :data-source="state.card.dataSource"
          :pagination="false"
        >
          <template #card_type="{ record }">
            <a-tag v-if="record.card_type === 0" color="green">面部单</a-tag>
            <a-tag v-if="record.card_type === 10" color="green">身体单</a-tag>
            <a-tag v-if="record.card_type === 20" color="green">产品单</a-tag>
            <a-tag v-if="record.card_type === 2" color="cyan">套餐</a-tag>
            <a-tag v-if="record.card_type === 21" color="red">产品卡</a-tag>
            <a-tag v-if="record.card_type === 11" color="red">时间卡</a-tag>
            <a-tag v-if="record.card_type === 1" color="red">次数卡</a-tag>
            <a-tag v-if="record.card_type === 31" color="red">二次卡</a-tag>
          </template>
          <template v-for="col in ['num']" #[col]="{ record }" :key="col">
            <div v-if="record.card_type === 1 || record.card_type === 21">
              <a-input v-model:value="record[col]" style="margin: -5px 0" />
            </div>
            <div v-if="record.card_type === 11">{{ record.max_num }}</div>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="() => handleDeleteCardRow(record.unique_key)">
              删除
            </a-button>
          </template>
        </a-table>
        <label title="单详情">单详情</label>
        <a-button type="primary" size="small" @click="() => handleAddProjectRow()">新增</a-button>
        <a-table
          :scroll="{ y: 400 }"
          :columns="state.project.columns"
          row-key="id"
          :data-source="state.project.dataSource"
          :pagination="false"
        >
          <template #project_type__p_type="{ record }">
            <a-tag v-if="record.project_type__p_type === 0" color="green">面部单</a-tag>
            <a-tag v-if="record.project_type__p_type === 10" color="green">身体单</a-tag>
            <a-tag v-if="record.project_type__p_type === 20" color="green">产品单</a-tag>
            <a-tag v-if="record.project_type__p_type === 2" color="cyan">套餐</a-tag>
            <a-tag v-if="record.project_type__p_type === 21" color="red">产品卡</a-tag>
            <a-tag v-if="record.project_type__p_type === 11" color="red">时间卡</a-tag>
            <a-tag v-if="record.project_type__p_type === 1" color="red">次数卡</a-tag>
            <a-tag v-if="record.project_type__p_type === 30" color="red">外科单</a-tag>
          </template>
          <template v-for="col in ['num']" #[col]="{ record }" :key="col">
            <div>
              <a-input v-model:value="record[col]" style="margin: -5px 0" />
            </div>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="() => handleDeleteProjectRow(record.unique_key)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import {
  create_project_set,
  update_project_set,
  get_project_set_item_detail,
  query_card_list,
  query_project_list,
} from '@/api/mjstore-model';
import { notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import modalBox from '@/components/form-modal/modal-tools';
import {useForm} from "ant-design-vue/es/form";

export default defineComponent({
  name: 'Projectsetmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const loading = ref(false);
    const card_ids: Array<number> = reactive([]);
    const project_ids: Array<number> = reactive([]);
    const formModel = reactive({
      card_ids: card_ids,
      project_ids: project_ids,
      project_set_id: null,
      project_type_id: null,
      name: null,
      code: null,
      price: null,
      p_type: [2],
      ...props.obj,
    });
    const rulesRef = reactive({
      name: [{ required: true, message: '请填写套餐名称' }],
      price: [{ required: true, message: '请填写套餐价格' }],
      project_type_id: [{ required: true, message: '请选择项目分类' }],
    });

    const {validate, validateInfos } = useForm(formModel, rulesRef);

    const modifyModal = reactive({
      title: '新建套餐',
      form: {
        settings: {
          labelAlign: 'right',
          layout: 'horizontal',
          labelCol: {
            span: 6,
          },
          wrapperCol: {
            span: 18,
          },
        },
        fields: [
          {
            type: 'input',
            name: 'name',
            label: '套餐名称',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            defaultValue: '',
            placeholder: '请填写套餐名称',
          },
          {
            type: 'number',
            name: 'price',
            label: '套餐价格',
            disabled: false,
            allowClear: true,
            precision: 0,
            inputType: 'number',
            defaultValue: '',
            placeholder: '请填写套餐价格',
          },
          {
            type: 'remoteselect',
            name: 'project_type_id',
            label: '项目分类',
            disabled: false,
            placeholder: '请选择项目分类',
            datasourceType: 'remote',
            mode: 'default',
            allowClear: true,
            valueKey: 'id',
            labelKey: 'name',
            modalType: 'mjstore-projecttype2',
          },
        ],
        rules: rulesRef,
        model: formModel,
      },
      validateInfos: validateInfos,
      options: {},
    });
    const cardDataSource: Array<any> = reactive([]);
    const projectDataSource: Array<any> = reactive([]);
    const state = reactive({
      card: {
        columns: [
          {
            title: '卡名称',
            dataIndex: 'name',
            key: 'name',
            width: '50%',
            slots: { customRender: 'name' },
          },
          {
            title: '编号',
            dataIndex: 'code',
            key: 'code',
            width: '50%',
            slots: { customRender: 'code' },
          },
          {
            title: '价格',
            dataIndex: 'price',
            key: 'price',
            width: '50%',
            slots: { customRender: 'price' },
          },
          {
            title: '类型',
            dataIndex: 'card_type',
            key: 'card_type',
            width: '50%',
            slots: { customRender: 'card_type' },
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '50%',
            slots: { customRender: 'num' },
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'action',
            slots: { customRender: 'action' },
          },
        ],
        dataSource: cardDataSource,
      },
      project: {
        columns: [
          {
            title: '单名称',
            dataIndex: 'name',
            key: 'name',
            width: '50%',
          },
          {
            title: '编号',
            dataIndex: 'code',
            key: 'code',
            width: '50%',
            slots: { customRender: 'code' },
          },
          {
            title: '价格',
            dataIndex: 'price',
            key: 'price',
            width: '50%',
            slots: { customRender: 'price' },
          },
          {
            title: '类型',
            dataIndex: 'project_type__p_type',
            key: 'project_type__p_type',
            width: '50%',
            slots: { customRender: 'project_type__p_type' },
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '50%',
            slots: { customRender: 'num' },
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'action',
            slots: { customRender: 'action' },
          },
        ],
        dataSource: projectDataSource,
      },
    });

    if (props.obj && props.obj.id > 0) {
      get_project_set_item_detail({ org_id: current_org.id, project_set_id: props.obj.id }).then(
        (res: any) => {
          Object.assign(formModel, res);
          formModel.project_set_id = props.obj.id;
          state.card.dataSource.length = 0;
          state.project.dataSource.length = 0;
          res.card_item.map((item: any, index: any) => {
            item.unique_key = new Date().getTime() + index;
            if (item.card_id == 11) {
              item.num = item.month_num;
            } else {
              item.num = item.project_set_num;
            }
            state.card.dataSource.push(item);
          });
          res.item.map((item: any, index: any) => {
            item.unique_key = new Date().getTime() + index;
            item.num = item.project_set_num;
            state.project.dataSource.push(item);
          });
        },
      );
    }

    const handleCancel = () => {
      emit('cancel');
    };
    const handleOk = () => {
      validate()
        .then(() => {
          if (props.obj && props.obj.id) {
            const item_list: any[] = [];
            const card_item_list: any[] = [];
            state.card.dataSource.forEach((item: any) => {
              card_item_list.push({ id: item.id, num: item.num });
            });
            state.project.dataSource.forEach((item: any) => {
              item_list.push({ id: item.id, num: item.num });
            });
            update_project_set({
              project_set_id: props.obj.id,
              org_id: current_org.id,
              code: formModel.code,
              name: formModel.name,
              price: formModel.price,
              project_type_id: formModel.project_type_id,
              item_json: JSON.stringify(item_list),
              card_item_json: JSON.stringify(card_item_list),
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '修改套餐成功',
                });
                emit('ok');
              })
              .finally(() => {
                loading.value = false;
              });
          } else {
            const item_list: any[] = [];
            const card_item_list: any[] = [];
            state.card.dataSource.forEach((item: any) => {
              card_item_list.push({ id: item.id, num: item.num });
            });
            state.project.dataSource.forEach((item: any) => {
              item_list.push({ id: item.id, num: item.num });
            });
            create_project_set({
              org_id: current_org.id,
              name: formModel.name,
              code: formModel.code,
              price: formModel.price,
              project_type_id: formModel.project_type_id,
              item_json: JSON.stringify(item_list),
              card_item_json: JSON.stringify(card_item_list),
            })
              .then(() => {
                notification.success({
                  message: '成功',
                  description: '新建套餐成功',
                });
                emit('ok');
              })
              .finally(() => {
                loading.value = false;
              });
          }
        })
        .finally(() => {})
        .catch(err => {
          console.log('error', err);
        });
    };
    const handleAddCardRow = () => {
      const editModal = reactive({
        visible: true,
        title: '选择卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'card_ids',
              label: '卡',
              disabled: false,
              placeholder: '请选择卡',
              datasourceType: 'remote',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-card',
            },
          ],
          rules: {},
          model: {
            org_id: current_org?.id,
          },
        },
        options: {},
        ok: (payload: any) => {
          query_card_list({
            org_id: current_org.id,
            page_size: 2000,
            page_index: 1,
            ids: payload.card_ids,
            is_active: true,
          }).then(res => {
            res.data.map((item, index) => {
              item.unique_key = new Date().getTime() + index;
              state.card.dataSource.push(item);
            });
          });
        },
      });
      modalBox(editModal);
    };
    const handleDeleteCardRow = (obj_unique_key: any) => {
      const source_list = [...state.card.dataSource];
      state.card.dataSource.length = 0;
      source_list.forEach(item => {
        if (item.unique_key != obj_unique_key) {
          state.card.dataSource.push(item);
        }
      });
    };
    const handleAddProjectRow = () => {
      const editModal = reactive({
        visible: true,
        title: '选择单',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'project_ids',
              label: '单',
              disabled: false,
              placeholder: '请选择单',
              datasourceType: 'remote',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-project',
            },
          ],
          rules: {},
          model: {
            org_id: current_org?.id,
          },
        },
        options: {},
        ok: (payload: any) => {
          query_project_list({
            org_id: current_org.id,
            page_size: 2000,
            page_index: 1,
            ids: payload.project_ids,
            is_active: true,
          }).then(res => {
            res.data.map((item, index) => {
              item.unique_key = new Date().getTime() + index;
              state.project.dataSource.push(item);
            });
          });
        },
      });
      modalBox(editModal);
    };
    const handleDeleteProjectRow = (obj_unique_key: any) => {
      const source_list = [...state.project.dataSource];
      state.project.dataSource.length = 0;
      source_list.forEach(item => {
        if (item.unique_key != obj_unique_key) {
          state.project.dataSource.push(item);
        }
      });
    };
    return {
      // fullscreen
      message,
      // edit
      loading,
      state,
      modifyModal,
      handleAddCardRow,
      handleDeleteCardRow,
      handleAddProjectRow,
      handleDeleteProjectRow,
      handleCancel,
      handleOk,
    };
  },
});
</script>
